import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/common/layout';
// import { ArticleContainer } from '../components/common/layout/container';
import { Heading } from 'components/common/typography';
// import MainImage from 'images/catalogue/categories/storage/800-series-modular-shelving-3.webp';
import { renderAst } from 'lib/cms';
import { ImageGrid, Article, Header, GalleryContainer } from 'components/pages/category/template';
import Card from 'components/pages/category/card';
import SEO from 'components/common/seo';

const Category = ({ data }) => {
    const { frontmatter } = data.markdownRemark;
    
    return (
        <Layout>
            <SEO 
                title={frontmatter.title}
            />
            <Article>
                <Header>
                    <Heading appearance="trafalgar">{frontmatter.title}</Heading>
                </Header>
                <div>{renderAst(data.markdownRemark.htmlAst)}</div>
                <GalleryContainer>
                    {data.secondaryImages && data.secondaryImages.edges.length > 0 && (
                        <Heading as="h2" appearance="paragon">Sample {frontmatter.title} products from our extensive catalogue.</Heading>
                    )}
                    <ImageGrid> 
                        {data.secondaryImages.edges.map(({ node }, i) => {
                            const { title, manufacturer } = getImageMeta(node.base);
                            return (
                                <Card key={i} src={node.childImageSharp.fluid} title={title} manufacturer={manufacturer} />
                            )
                        })}
                    </ImageGrid>
                </GalleryContainer>
            </Article>
        </Layout>
    );
};

export function getImageMeta(filename) {

    let base = filename.split('.')[0];
    let title = '', manufacturer = '';

    if(/_\d+$/.test(base)) {
        base = base.split(/_/)[0];
    }

    if(/-by-/.test(base)) {
        const parts = base.split('-by-');
        title = parts[0].replace(/-/g, ' ');
        manufacturer = parts[1].replace(/-/g, ' ');
    } else {
        title = base.replace(/-/g, ' ');
    }

    if(title === 'PosturaPlus') {
        title = 'Postura+';
    }
    

    return { title, manufacturer };
}

export default Category;

export const categoryQuery = graphql`
    query($path: String!, $secondaryImagesRegex: String!) {
        markdownRemark(frontmatter: { path: { eq: $path }}) {
            htmlAst
            frontmatter {
                title
            }
        }
        secondaryImages: allFile(
            filter: {
                absolutePath: {regex: $secondaryImagesRegex}, 
                extension: {regex: "/(jpg)|(jpeg)|(png)/"}
            },
            sort: {
                fields: base,
                order: ASC
            }
        ) {
            edges {
                node {
                    base
                    childImageSharp {
                        fluid(maxWidth: 400, maxHeight: 400, cropFocus: CENTER) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    }
`;